import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ObjectListName from 'automation-ui-references/customer-data/ObjectListName';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AlterListMembershipActionSummary({
  actionMetadata
}) {
  const {
    shouldAdd,
    listId
  } = actionMetadata;
  const messageKey = shouldAdd ? 'automation-ui-action-features.action-features.alter-list-membership.summary.add' : 'automation-ui-action-features.action-features.alter-list-membership.summary.remove';
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: messageKey,
    options: {
      listName: /*#__PURE__*/_jsx(ObjectListName, {
        id: listId
      })
    }
  });
}